<template>
  <div class="invoice">
    <div class="title">发票要素</div>
    <div class="content content-top">
      <div class="left">
        <div class="top">{{title.title}}</div>
        <div class="bottom">{{card.Content || '--'}}</div>
      </div>
      <div class="center">
        <div class="top">{{title.title1}}</div>
        <div class="bottom">{{card.Content1}}</div>
      </div>
      <div class="right">
        <div class="top">{{title.title2}}</div>
        <div class="bottom">{{card.Content2}}</div>
      </div>
    </div>
    <div class="content content-bottom" v-if="title.title3">
      <div class="left">
        <div class="top">{{title.title3}}</div>
        <div class="bottom">{{card.Content3}}</div>
      </div>
      <div class="center">
        <div class="top">{{title.title4}}</div>
        <div class="bottom">{{card.Content4}}</div>
      </div>
      <div class="right">
        <div class="top">{{title.title5}}</div>
        <div class="bottom">{{card.Content5}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeNames: ['']
    }
  },
  components: {

  },
  props: {
    title: {
      type: Object,
      default: () => {}
    },
    card: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="less" src="./style.less" scoped></style>
